// import React from 'react';
// import IndexRouter from '@/router/IndexRouter.js';
// import { ConfigProvider } from 'antd';

// import 'antd/dist/reset.css';  
// import './App.css';
// export default function App() {
//   return (
//     <ConfigProvider
//       theme={{
//         token: {
//           fontSize: 13, 
//         },
//       }}
//     >
//       <IndexRouter />
//     </ConfigProvider>
//   );
// }

import React from 'react';
import IndexRouter from '@/router/IndexRouter.js';
import { ConfigProvider } from 'antd';

import 'antd/dist/reset.css';
import './App.css';

export default function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: 14,
          fontFamily:
            "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        },
      }}
    >
      <IndexRouter />
    </ConfigProvider>
  );
}